import { select, Store } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectRelationshipCategoryInStore,
  selectRelationshipCategoryPageLoading,
  selectRelationshipCategoryShowInitWaitingMessage,
} from '../_selectors/relationship-category.selectors';

export class RelationshipCategoryDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectRelationshipCategoryPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectRelationshipCategoryShowInitWaitingMessage),
    );

    this.store
      .pipe(select(selectRelationshipCategoryInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
